import React, { Component, Fragment } from "react";
import { Icon, Button } from "antd";
import ConfirmButton from "./../buttons/ConfirmButton";
import CancelButton from "./../buttons/CancelButton";

class ButtonStep extends Component {
  render() {
    const { current, steps, prev, next, sucess, disabled, nextLabel, hideNextLabelIcon } = this.props;
    return (
      <div className="p-mrg-top p-mrg-bot p-al-right">
        {current > 0 && (
          <CancelButton
            label={nextLabel ? nextLabel : "Précédent"}
            large={true}
            classes={"p-mrg-right p-btn-light-orange"}
            onClick={current => prev(current)}
          />
        )}
        {current < steps.length - 1 && (
          <ConfirmButton
            label={nextLabel ? nextLabel : "Suivant"}
            large={true}
            disabled={disabled}
            onClick={current => next(current)}
          />
        )}
        {current === steps.length - 1 && (
          <ConfirmButton
            label={nextLabel ? nextLabel : "Terminer"}
            large={true}
            disabled={disabled}
            onClick={current => sucess(current)}
          />
        )}
      </div>
    );
  }
}

export default ButtonStep;



// WEBPACK FOOTER //
// src/components/survey/ButtonStep.js